import classNames from 'classnames';
import React from 'react';
import { useRefinementList } from 'react-instantsearch-hooks-web';

export const BooleanRefinement = (props) => {
  const { items, refine } = useRefinementList(props);

  const renderLabel = (label) => {
    switch (label) {
      case 'true':
        return 'Yes';

      case 'false':
        return 'No';
    }
  };

  if (items.length <= 1) {
    return null;
  }

  const handleRefine = (value) => (ev) => {
    if (ev.code && ev.code !== 'Enter') {
      return;
    }
    refine(value);
  };

  return (
    <div className="ais-RefinementList" data-type={props.attribute}>
      <header>{props.title}</header>
      <ul className="ais-RefinementList-list">
        {items.map((item) => (
          <li
            key={item.value}
            className={classNames('ais-RefinementList-item', {
              'ais-RefinementList-item--selected': item.isRefined,
            })}
          >
            <label className="ais-RefinementList-label" tabIndex={0} onKeyDown={handleRefine(item.value)}>
              <input
                className="ais-RefinementList-checkbox"
                type="checkbox"
                value={item.value}
                checked={item.isRefined}
                onChange={handleRefine(item.value)}
              />
              <span className="ais-RefinementList-labelText">{renderLabel(item.label)}</span>
              {/* <span className="ais-RefinementList-count">{item.count}</span> */}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};
